import { useState } from "react";
import { Search } from "lucide-react";
import { C, Table, Td, Chip, StatusChip, Serif, Label } from "./ui";
import { CUSTOMERS } from "./adminData";

export default function Customers({ nav, product }) {
  const [q, setQ] = useState("");
  const rows = CUSTOMERS.filter((c) => (product === "all" || c.product === product) && c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 18 }}>
        <div>
          <Label>Customer base</Label>
          <Serif size={26} style={{ marginTop: 4 }}>Customers</Serif>
        </div>
        <div style={{ position: "relative" }}>
          <Search size={15} style={{ position: "absolute", left: 12, top: 11, color: C.slate }} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name…" data-testid="customers-search"
            style={{ padding: "9px 14px 9px 34px", border: "1px solid rgba(26,30,36,0.14)", borderRadius: 8, fontSize: 13, outline: "none", width: 220 }} />
        </div>
      </div>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 12 }}>
        Showing <b style={{ color: C.ink }}>{rows.length}</b> of {CUSTOMERS.length} · {product === "all" ? "all products" : product === "consumer" ? "ResQ1 Consumer" : "ResQconnect Commercial"}
      </div>
      <Table head={["Name", "Cell", "Insurer", "Plan", "Product", "App", "Incidents", "Status"]}>
        {rows.map((c, i) => (
          <tr key={c.id} onClick={() => nav("customer")} data-testid={`customer-row-${i}`} style={{ cursor: "pointer" }}>
            <Td style={{ fontWeight: 600 }}>{c.name}</Td>
            <Td style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: C.slate }}>{c.cell}</Td>
            <Td>{c.insurer}</Td>
            <Td style={{ color: C.slate }}>{c.plan}</Td>
            <Td><Chip color={c.product === "consumer" ? C.red : C.navy}>{c.product === "consumer" ? "ResQ1" : "Commercial"}</Chip></Td>
            <Td><span style={{ color: c.hasApp ? C.green : C.slate, fontWeight: 700 }}>{c.hasApp ? "● Yes" : "○ No"}</span></Td>
            <Td style={{ fontFamily: "'JetBrains Mono', monospace" }}>{c.incidents}</Td>
            <Td><StatusChip status={c.status} /></Td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
